import { ajax } from './ajax.function';

export const post = (url: string, data?: Record<string, any>, authorization?: string) => ajax('POST', url, data, authorization);
